export default __webpack_public_path__ + "img/f8dffdc7edad1702e50d44a2a5a87996.png";